import { motion } from "framer-motion";
import { useCms } from "@/lib/cms";
import { DEFAULT_BRAND_LOGO, resolveBrandLogoUrl } from "@/lib/brandLogo";
import "./BrandIntroSection.css";

function applyLogoFallback(event) {
  const img = event.currentTarget;
  if (img.dataset.fallbackApplied === "true") return;
  img.dataset.fallbackApplied = "true";
  img.src = DEFAULT_BRAND_LOGO;
}

const PILLARS = [
  {
    title: "Digital",
    text: "디지털 기술로 비즈니스의 가능성을 확장하고, 데이터와 시스템을 연결합니다.",
  },
  {
    title: "Dynamic",
    text: "변화하는 시장과 운영 환경에 유연하게 대응하는 구조와 경험을 만듭니다.",
  },
  {
    title: "Design",
    text: "브랜드와 사용자 모두에게 설득력 있는 인터페이스와 경험을 설계합니다.",
  },
];

export default function BrandIntroSection() {
  const { cms } = useCms();
  const brandName = (cms?.company_name || "DSITESOLUTION").toUpperCase();
  const logoUrl = resolveBrandLogoUrl(cms?.media_logo);

  return (
    <section
      id="brand"
      data-testid="brand-intro-section"
      className="ds-brand-intro"
      aria-label="브랜드 소개"
    >
      <div className="ds-brand-intro__inner">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="ds-brand-intro__logo-block"
        >
          <div className="ds-brand-intro__label">Brand Identity — 00</div>

          <div className="ds-brand-intro__logo-wrap">
            <img
              src={logoUrl}
              alt={brandName}
              className="ds-brand-intro__logo"
              loading="eager"
              decoding="async"
              onError={applyLogoFallback}
            />
          </div>

          <p className="ds-brand-intro__site-copy font-kr">
            <strong>Site</strong>는 공간·현장·플랫폼을 의미합니다. D Site Solution은 기업의 디지털
            공간 전체를 설계하고, 브랜드가 온·오프라인에서 신뢰를 쌓을 수 있는 환경을 만듭니다.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
          className="ds-brand-intro__content"
        >
          <div className="ds-brand-intro__brand">
            <img
              src={logoUrl}
              alt=""
              className="ds-brand-intro__brand-mark"
              loading="lazy"
              onError={applyLogoFallback}
            />
            <div className="ds-brand-intro__brand-copy">
              <div className="ds-brand-intro__brand-name">{brandName}</div>
              <div className="ds-brand-intro__brand-tagline">NO. 1 BRAND DIGITAL SOLUTION</div>
            </div>
          </div>

          <p className="ds-brand-intro__quote font-kr">
            기술은 사용자가 느끼지 못할 때 완벽합니다.
            <br />
            D Site Solution은 보이지 않는 곳에서 브랜드 경험을 완성합니다.
          </p>

          <div className="ds-brand-intro__pillars">
            {PILLARS.map((item) => (
              <div key={item.title} className="ds-brand-intro__pillar">
                <div className="ds-brand-intro__pillar-mark" aria-hidden="true" />
                <div className="ds-brand-intro__pillar-title">{item.title}</div>
                <p className="ds-brand-intro__pillar-text font-kr">{item.text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
